import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLogo } from '../pages/Beneficiary/Auth/companyLogoApi'
import { companyLogoSelectors } from '../pages/Beneficiary/Auth/companyLogoSlice'

const useCompanyLogo = domainName => {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getLogo(domainName))
    }, [domainName])

    const isFetching = useSelector(companyLogoSelectors.isFetching)
    const hasError = useSelector(companyLogoSelectors.hasError)
    const has404Error = useSelector(companyLogoSelectors.has404Error)
    const logo = useSelector(companyLogoSelectors.logo)
    const companyName = useSelector(companyLogoSelectors.companyName)

    return {
        isFetching,
        hasError,
        logo,
        companyName,
        has404Error,
    }
}

export default useCompanyLogo
